import React, { useState, FC, useMemo, useEffect, MouseEvent, useCallback } from 'react';
import { NavContext } from './NavContext';
import { flatMap, isEmpty, find, get } from 'lodash';
import { useMedia } from '../util';
import { ParentMap, NavMenuItem } from './SideNavTypes';

const flatSubMenuList = (item: NavMenuItem, flattenItems: ParentMap[], parents: string[]) => {
  if (!isEmpty(item.subMenuList)) {
    for (const itm of item.subMenuList) {
      const { navId, subMenuList } = itm;
      flattenItems.push({
        navId,
        parents
      });
      if (!isEmpty(subMenuList)) {
        flatSubMenuList(itm, flattenItems, [...parents, navId]);
      }
    }
  }
};
const flatItems = (items: NavMenuItem[]): ParentMap[] =>
  flatMap(items, item => {
    const { navId } = item;
    const tempArray = [
      {
        navId
      }
    ];
    flatSubMenuList(item, tempArray, [navId]);
    return tempArray;
  });

export const NavContextProvider: FC<{
  defaultActive;
  items: NavMenuItem[];
  onSelect?: (navId: string, e: MouseEvent) => void;
  children?: React.ReactNode;
}> = ({ defaultActive, children, items, onSelect }) => {
  const isMobile = useMedia([`(max-width: 991.98px)`], [true], false);
  const [activeKey, setActiveKey] = useState<string>(defaultActive);
  const [dropOpen, setDropOpen] = useState<string>();
  const [dropSubMenuOpen, setDropSubMenuOpen] = useState<string>();

  const flatItem = useMemo(() => flatItems(items), [items]);

  const defaultItem = find(flatItem, { navId: defaultActive });
  const [activeParents, setActiveParents] = useState<string[]>(get(defaultItem, 'parents'));
  useEffect(() => {
    setActiveParents(get(find(flatItem, { navId: activeKey }), 'parents', []));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, isMobile]);
  const getParent = useCallback(
    (navId: string) => {
      return get(find(flatItem, { navId }), 'parents', []);
    },
    [flatItem]
  );
  const [mobileToggle, setMobileToggle] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [clickedOutside, setClickedOutside] = useState(false);
  return (
    <NavContext.Provider
      value={{
        activeKey,
        setActiveKey,
        activeParents,
        mobileToggle,
        setMobileToggle,
        isMobile,
        onSelect,
        getParent,
        dropOpen,
        dropSubMenuOpen,
        setDropOpen,
        setDropSubMenuOpen,
        showContact,
        setShowContact,
        clickedOutside,
        setClickedOutside
      }}>
      {children}
    </NavContext.Provider>
  );
};

NavContextProvider.displayName = 'NavContextProvider';
export default NavContextProvider;
